<template>
  <g class="falla-arm-1000">
    <g class="armFar" v-if="doubleBranch && side === 'far'">
  <g class="arm-bracket">
    <polygon class="topside" points="1676.54 3419.57 1775.27 3476.57 1792.59 3466.57 1693.86 3409.57" fill="#5b9bd5"/>
    <polygon class="frontside" points="1676.54 3539.57 1775.27 3596.57 1775.27 3476.57 1676.54 3419.57" fill="#3f7fbb"/>
    <polygon class="main-rightside" points="1775.27 3596.57 1792.59 3586.57 1792.59 3466.57 1775.27 3476.57" fill="#316496"/>
  </g>
  <g class="arm-bracket-grip">
    <polygon class="topside" points="1725.91 3498.07 1731.97 3501.57 1775.27 3476.57 1769.21 3473.07" fill="#5b9bd5"/>
    <polygon class="frontside" points="1725.91 3618.07 1731.97 3621.57 1731.97 3501.57 1725.91 3498.07" fill="#3f7fbb"/>
    <polygon class="main-rightside" points="1731.97 3621.57 1775.27 3596.57 1775.27 3476.57 1731.97 3501.57" fill="#316496"/>
  </g>
  <g class="arm">
    <polygon class="topside" points="1686.93 3450.57 1764.88 3495.57 2630.90 2995.57 2552.96 2950.57" fill="#5b9bd5"/>
    <polygon class="frontside" points="1686.93 3520.57 1764.88 3565.57 1764.88 3495.57 1686.93 3450.57" fill="#3f7fbb"/>
    <polygon class="main-rightside" points="1764.88 3565.57 2630.90 3065.57 2630.90 2995.57 1764.88 3495.57" fill="#316496"/>
  </g>
    </g>
    <g class="armNear" v-if="side !== 'far'">
  <g class="arm-bracket">
    <polygon class="topside" points="1503.34 3519.57 1602.06 3576.57 1619.38 3566.57 1520.66 3509.57" fill="#5b9bd5"/>
    <polygon class="frontside" points="1503.34 3639.57 1602.06 3696.57 1602.06 3576.57 1503.34 3519.57" fill="#3f7fbb"/>
    <polygon class="main-rightside" points="1602.06 3696.57 1619.38 3686.57 1619.38 3566.57 1602.06 3576.57" fill="#316496"/>
  </g>
  <g class="arm-bracket-grip">
    <polygon class="topside" points="1613.32 3563.07 1619.38 3566.57 1662.69 3541.57 1656.62 3538.07" fill="#5b9bd5"/>
    <polygon class="frontside" points="1613.32 3683.07 1619.38 3686.57 1619.38 3566.57 1613.32 3563.07" fill="#3f7fbb"/>
    <polygon class="main-rightside" points="1619.38 3686.57 1662.69 3661.57 1662.69 3541.57 1619.38 3566.57" fill="#316496"/>
  </g>
  <g class="arm">
    <polygon class="topside" points="665.02 4040.57 742.97 4085.57 1608.99 3585.57 1531.05 3540.57" fill="#5b9bd5"/>
    <polygon class="frontside" points="665.02 4110.57 742.97 4155.57 742.97 4085.57 665.02 4040.57" fill="#3f7fbb"/>
    <polygon class="main-rightside" points="742.97 4155.57 1608.99 3655.57 1608.99 3585.57 742.97 4085.57" fill="#316496"/>
  </g>
    </g>
  </g>
</template>
<script>
export default {
  props: {
    doubleBranch: Boolean,
    side: String,
  },

  name: "Arm1000-F.vue",
};
</script>
